import React from "react";
import { useSelector } from 'react-redux';
import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { CloseIcon, PencilIcon } from "../AllSvgIcon";
import t from '../../i18n/translate';

const CardWrapper = styled.label`
  border-radius: 6px;
  background-color: ${themeGet("colors.lightColor", "#F7F7F7")};
  border: 1px solid ${themeGet("colors.lightColor", "#F7F7F7")};
  padding: 15px 20px;
  position: relative;
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.2", "12")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
  line-height: 24px;
  cursor: pointer;
  transition: all 0.25s ease;

  &.active {
    border: 1px solid ${themeGet("colors.primary", "#9cc54b")};
    background-color: #ffffff;
    
    &.express { border: 1px solid #f01266; }
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &.item-has-title {
    flex-direction: column;
    text-align: left;
    align-items: flex-start;
    padding: 15px;
  }

  &:last-child {
    margin-right: 0;
  }

  input[type="radio"] {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }

  &:hover {
    .button-wrapper {
      opacity: 1;
      visibility: visible;
    }
  }

  @media screen and (max-width:420px){
    min-width: 300px !important;
  }
`;
const CartNumber = styled.div`
font-family: "Lato", sans-serif;
font-size: 18px;
font-weight: 800;
color: #000;
margin-bottom: 10px;
text-transform: capitalize;
display: flex;
flex-wrap: wrap;
`
const CardTitle = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.1", "15")}px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
  line-height: 1.2;
  margin-bottom: 5px;
  text-transform: capitalize;
`;
const CardContent = styled.span`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkMedium", "#424561")};
`;
const CardButtons = styled.span`
  display: block;
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: 0.2s ease-in-out;
`;
const ActionButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  overflow: hidden;
  margin-left: 5px;
  cursor: pointer;
  outline: 0;
  padding: 0;
  color: #fff;

  &.edit-btn {
    background-color: ${themeGet("colors.primary", "#9cc54b")};
    &.express { background-color: #f01266 }
  }
  &.delete-btn {
    background-color: ${themeGet("colors.secondary", "#ff5b60")};
  }

  svg {
    display: block;
    width: 8px;
    height: auto;
  }
`;
const CardLogo = styled.img`
  height: 30px;
  margin-bottom: 20px;
`;
const CardHolderName = styled.div`
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 600;
`;
const CardExpireDate = styled.div`
  display: flex;
  font-size: 14px;
`
const PaymentRadioCard = ({
  id,
  value,
  name,
  cust_id,
  card_token,
  swift_code,
  holder_name,
  account_logo,
  account_name,
  account_number,
  month,
  year,
  isExpired,
  checked,
  onDelete,
  onEdit,
  onChange,
  withActionButtons,
  hasDelete,
  hasEdit,
  editIcon,
  deleteIcon,
  disabled
}) => {
  const cartType = useSelector(state => state.cartReducer.cartType);

  return (
    <CardWrapper
      htmlFor={`${name}-${id}`}
    //   className={`label ${cartType} ${title ? "item-has-title" : "item-has-title"}
    //   ${checked ? "active" : "not_active"}`}
    >
      <input
        type="radio"
        id={`${name}-${id}`}
        name={name}
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
        {account_logo && <CardLogo src={account_logo}/>}
        {holder_name && <CardHolderName>{holder_name}</CardHolderName>}
        {account_name && account_number&& <CartNumber><span>{account_name}</span>: <span>{account_number}</span></CartNumber>}
        <CardExpireDate className={`${isExpired === 1 && 'float-right'}`}>{isExpired === 0 ? <div className="d-flex align-items-center"><p>Expiry Date: </p><span className="muted ml-1">{month < 10 ? 0 : null }{month}/{year}</span></div> : <span className="text-danger">Expired</span>}</CardExpireDate>
      {withActionButtons && (
        <CardButtons className="button-wrapper">
          {hasEdit && (
            <ActionButton onClick={onEdit} className={`edit-btn ${cartType}`}>
              {editIcon}
            </ActionButton>
          )}
          {hasDelete && (
            <ActionButton onClick={onDelete} className="delete-btn">
              {deleteIcon}
            </ActionButton>
          )}
        </CardButtons>
      )}
    </CardWrapper>
  );
};
PaymentRadioCard.defaultProps = {
  title: "",
  content: "",
  editIcon: <PencilIcon />,
  deleteIcon: <CloseIcon />,
  withActionButtons: true,
  hasEdit: true,
  hasDelete: true,
};
export default PaymentRadioCard;
